.mealIcon {
  color: var(--color-icon--meal);
}

.methodHeader {
  display: flex;
  align-items: center;
  color: rgba(var(--color-blue-bayoux-rgb), 0.6);
}

.methodTitle {
  margin-left: 2rem;
  color: var(--color-light-slate-grey);
  font-weight: bold;
  font-size: 1.6rem;
  line-height: 1.9rem;
}

.methodDescription {
  margin-top: 2.4rem;
  color: var(--color-light-slate-grey);
  font-size: 1.4rem;
  line-height: 2.2rem;
}

.methodDescription p {
  margin-top: 3rem;
}

.methodDescription a {
  color: var(--color-shadow-green);
  font-weight: bold;
}
